//整个页面加载动画
export const PAGE_LOADING_QUERY = 'PAGE_LOADING_QUERY'
//vue-router分片加载动画
export const PAGE_ROUTER_LOADING = 'PAGE_ROUTER_LOADING'








// WEBPACK FOOTER //
// ./src/store/types.js